module.exports = __webpack_public_path__ + "static/media/laborleiter_tuer_mit_markierung.04fb3a32.jpg";